<template>
  <div class="down-center">
    <div class="wrap">
      <div class="list">
        <div class="item" v-for="(it, idx) in list" :key="idx">
          <div class="left">
            <span class="title" :title="it.title">{{ it.title }}</span>
          </div>
          <div class="meta">
            <div class="format-box">
              <img :src="fileName(it.url)" style="width: 40px" v-if="it.url" />
            </div>
            <span class="size">{{ formatSize(it.size) }}</span>
            <span class="date">{{ it.date }}</span>
            <span class="download" @click="download(it)">
              <img
                src="@assets/img/upload.png"
                style="width: 32px; height: 32px"
              />
            </span>
          </div>
        </div>
        <div class="u-empty" v-if="loading">数据加载中...</div>
        <div class="u-empty" v-else-if="!loading && !list.length">暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Docx from "@assets/img/type/docx.png";
import Png from "@assets/img/type/png.png";
import Jpg from "@assets/img/type/jpg.png";
import Pdf from "@assets/img/type/pdf.png";
import Ppt from "@assets/img/type/ppt.png";
import Txt from "@assets/img/type/txt.png";
import Unkown from "@assets/img/type/unknow.png";
import Xls from "@assets/img/type/xls.png";
import Zip from "@assets/img/type/zip.png";
export default {
  name: "down-center",
  data() {
    return {
      list: [],
      loading: true,
    };
  },
  computed: {
    ...mapGetters({
      exhibitionId: "getExhibitionId",
    }),
    imgArr() {
      return {
        doc: Docx,
        docx: Docx,
        png: Png,
        jpg: Jpg,
        jpeg: Jpg,
        pdf: Pdf,
        ppt: Ppt,
        pptx: Ppt,
        txt: Txt,
        unkown: Unkown,
        xls: Xls,
        xlsx: Xls,
        zip: Zip,
      };
    },
  },
  created() {
    this.init();
  },
  methods: {
    fileName(file) {
      if (!file) return;
      //截取文件后缀
      let file_name = file.substring(file.lastIndexOf(".") + 1);
      let name = this.imgArr[file_name];
      return name ? name : this.imgArr["unkown"];
    },
    async init() {
      this.loading = true;
      let opt = {
        where: {
          Equal: {
            N: "exhibitionId",
            V: this.exhibitionId,
          },
          Equal2: {
            n: "isDeleted",
            v: false,
          },
        },
        order: [{ N: "showIndex", V: 0 }], // 展商秀2.0测试0907 50条 默认按话题的阅读数倒序（推荐的优先展示）
        page: 1,
        size: 999,
      };
      const { data } = await this.$http.post(
        `/api/v3/exhibitionvisitordatadownload/query`,
        opt
      );
      const arr = data.items || [];
      this.list = arr.map((e) => ({
        title: e.title || `${e.name || ""} ${e.remark || ""}`.trim(),
        size: e.size || e.fileSize || "",
        date:
          e.date || e.createAt || e.updateAt
            ? this.$moment(e.date || e.updateAt || e.createAt).format(
                "YYYY/MM/DD"
              )
            : "",
        url: e.url || e.link || e.downloadUrl || e.fileUrl || "",
      }));
      console.log("list", this.list);
      this.loading = false;
    },
    formatSize(sz) {
      if (sz === undefined || sz === null || sz === "") return "";
      const s = typeof sz === "string" ? sz : String(sz);
      if (/m$|mb$/i.test(s)) return s;
      const n = Number(sz);
      if (isNaN(n)) return s;
      return (n / (1024 * 1024)).toFixed(2) + "M";
    },
    async download(it) {
      if (!it || !it.url) return;
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = it.url;
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@assets/scss/my-theme/mixin.scss";
.format-box {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0;
  img {
    max-width: 40px;
    max-height: 40px;
  }
}
.down-center {
  min-height: 508px;
  width: 1200px;
  margin: 20px auto;
  .wrap {
    background: #fff;
    padding: 20px;
  }
  .list {
    display: block;
  }
  .size {
    width: 120px;
  }
  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f7f7f7;
    border-radius: 8px;
    padding: 12px 16px;
    margin-bottom: 12px;
  }
  .left {
    display: flex;
    align-items: center;
    flex: 1;
  }
  .title {
    color: #333;
  }
  .meta {
    display: flex;
    align-items: center;
    gap: 30px;
    color: #666;
  }
  .download {
    cursor: pointer;
    font-size: 18px;
    color: #1890ff;
    display: flex;
    align-items: center;
  }
}
</style>
